/*
 * File: index.tsx
 * Desc: 组合输入表单组件
 * File Created: 2020-03-31 09:26:44
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2020 - present, karakal
 */
import React from 'react';
import { Form, Input, Select } from 'antd';
import { FormBaseProps } from '../form-input';
import { FormProps } from 'antd/lib/form';
import { GetFieldDecoratorOptions } from 'antd/lib/form/Form';

interface IField extends FormBaseProps, GetFieldDecoratorOptions {
    type: 'input' | 'select';
    valueFilter?: Function;
    style?: React.CSSProperties;
    options?: { key: any; value: any }[];
}

interface FormGroupProps extends Omit<FormBaseProps, 'field'>, Omit<FormProps, 'onChange'> {
    fields: IField[];
}

const FormComps = {
    input: (props: any) => <Input {...props} />,
    select: (props: any) => (
        <Select {...props}>
            {props.options &&
                props.options.map((option: any) => (
                    <Select.Option value={option.key} key={option.key}>
                        {option.value}
                    </Select.Option>
                ))}
        </Select>
    ),
};

const FormGroup = (props: FormGroupProps) => {
    const { label, labelCol, wrapperCol, form, fields } = props;
    const { getFieldDecorator } = form!;

    return (
        <Form.Item
            {...{
                label,
                labelCol,
                wrapperCol,
            }}
            className={props.className}
        >
            <Input.Group compact>
                {fields.map(field => {
                    const Comp = FormComps[field.type];
                    return (
                        <Form.Item>
                            {getFieldDecorator(field.field, {
                                initialValue: field.initialValue,
                                rules: field.rules,
                                validateFirst: true, //当某一规则校验不通过时，是否停止剩下的规则的校验
                                normalize: (value: any) => {
                                    if (field.valueFilter) return field.valueFilter(value);
                                    return value;
                                },
                            })(<Comp {...field} key={field.field} />)}
                        </Form.Item>
                    );
                })}
            </Input.Group>
        </Form.Item>
    );
};

export default FormGroup;
